/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Actions_ConfirmInputs */

const es_components_upgrade_plan_modal_actions_confirm = /** @type {(inputs: Components_Upgrade_Plan_Modal_Actions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const en_components_upgrade_plan_modal_actions_confirm = /** @type {(inputs: Components_Upgrade_Plan_Modal_Actions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Components_Upgrade_Plan_Modal_Actions_ConfirmInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_actions_confirm = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Actions_ConfirmInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Actions_ConfirmInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_actions_confirm(inputs)
	return en_components_upgrade_plan_modal_actions_confirm(inputs)
});
export { components_upgrade_plan_modal_actions_confirm as "components.upgrade_plan_modal.actions.confirm" }